import React from "react";
import * as Icon from "react-feather";

import "./tools-document-pane.css";

import AFSService from "../../../../services/AFSService";

import WComponent from "../../../common/WComponent";

class ToolsDocumentPane extends WComponent {
	constructor(props) {
		super(props);

		this.state = { couldNotBeShown: false };
	}

	componentDidUpdate(previousProps) {
		const nowShowingSomethingElse = previousProps.documentId !== this.props.documentId || previousProps.evidenceItemId !== this.props.evidenceItemId;
		if (nowShowingSomethingElse && this.state.couldNotBeShown) this.update({ couldNotBeShown: false });
	}

	onFrameFailed = () => this.update({ couldNotBeShown: true });

	viewUrl = () => {
		const { documentId, evidenceItemId } = this.props;
		if (!documentId && !evidenceItemId) return null;

		return AFSService.getDocumentViewUrl({ documentId, evidenceItemId });
	};

	renderOpenInNewTab = ({ label }) => {
		const url = this.viewUrl();
		if (!url) return null;

		return (
			<a className="tk-doc-pane__open" href={url} target="_blank" rel="noopener noreferrer">
				<Icon.ExternalLink size={12} />
				{label}
			</a>
		);
	};

	renderMessage = ({ icon, text }) => (
		<div className="tk-doc-pane__message">
			{icon}
			<p>{text}</p>
			{this.renderOpenInNewTab({ label: "Open in a new tab" })}
		</div>
	);

	render() {
		const { title, nothingOnFileMessage, withOpenLink } = this.props;
		const url = this.viewUrl();

		if (!url) {
			return this.renderMessage({
				icon: <Icon.FileText size={20} />,
				text: nothingOnFileMessage || "No copy of this document was kept, so there is nothing to show.",
			});
		}

		if (this.state.couldNotBeShown) {
			return this.renderMessage({
				icon: <Icon.AlertTriangle size={20} />,
				text: "This document is on file but could not be displayed here.",
			});
		}

		return (
			<div className="tk-doc-pane">
				{withOpenLink && <div className="tk-doc-pane__bar">{this.renderOpenInNewTab({ label: "Open in a new tab" })}</div>}
				<iframe className="tk-doc-pane__frame" title={title || "Document"} src={url} onError={this.onFrameFailed} />
			</div>
		);
	}
}

export default ToolsDocumentPane;
